import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../store/store-keys'
import { IAuthState } from './auth.reducers'
import cloneDeep from 'lodash/cloneDeep'

export const selectAuth =
    createFeatureSelector<Readonly<IAuthState>>(StoreKeysEnum.CommonAuth)

export const selectAccessToken = createSelector(
    selectAuth,
    (data) => cloneDeep(data?.accessToken)
)